/* Weidelandfarm — sanftes Einblenden beim Scrollen. Respektiert prefers-reduced-motion. */
(function () {
  function start() {
    var elemente = document.querySelectorAll('.wlf-reveal:not(.wlf-sichtbar)');
    if (!elemente.length) return;

    var reduziert = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduziert || !('IntersectionObserver' in window)) {
      elemente.forEach(function (el) {
        el.classList.add('wlf-sichtbar');
      });
      return;
    }

    var beobachter = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('wlf-sichtbar');
            beobachter.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    elemente.forEach(function (el) {
      beobachter.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Im Theme-Editor neu eingefügte Sections ebenfalls einblenden */
  document.addEventListener('shopify:section:load', start);
})();
